import React from "react";
import {Amount, SelectedService} from "../../modification/model";

const isAmountType = (amount: any): amount is Amount => {
    return "amount" in amount;
}

export function ExtraRender(props: SelectedService) {
    const amountValue = isAmountType(props.amount) ? props.amount.amount : props.amount;
    const currency = isAmountType(props.amount) ? props.amount.currency : "";
    const unit = amountValue / (props.quantity || 1);
    return <>{props.quantity} x {unit.toFixed(2)} = {amountValue.toFixed(2)} {currency}</>
}
